import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { firewallPoliciesSelector } from '../selectors/dashboardSelector';
import { getFirewallPoliciesStatusRequest } from '../actions/dashboardActions';
import FirewallPoliciesStatus from '../components/FirewallPoliciesStatus/FirewallPoliciesStatus';

const mapStateToProps = createStructuredSelector({ firewallPolicies: firewallPoliciesSelector });
const mapDispatchToProps = { getFirewallPoliciesStatusRequest };

export default connect(mapStateToProps, mapDispatchToProps)(FirewallPoliciesStatus);
